import { BhapticsContent } from "@/store/reducers/contents";
import { useTrans } from "@/utils/useTrans";
import { Button } from "@/v2-components/ui/button";
import ReviewAndOpinionDialog from "@/v2-components/pages/games/detail/ReviewAndOpinionDialog";
import Image from "next/image";
import React from "react";

/**
 * TODO: 주석 풀어서 사용
 */

// import {
//   Accordion,
//   AccordionContent,
//   AccordionItem,
//   AccordionTrigger,
// } from "@/v2-components/ui/accordion";
// import ChevronDownIcon from "@/v2-components/core/icon/chevron-down-icon";

interface Props {
  game: BhapticsContent;
}
export default function Inquiry({ game }: Props) {
  const { t } = useTrans(["games"]);
  return (
    <div className="flex flex-col">
      {/* TODO: 나중에 기능이 들어오면 주석 풀어서 사용하세요 */}
      {/* <h2 className="mb-5 text-2xl laptop:text-3xl">Inquiry</h2>
      <Accordion type="single" collapsible>
        <AccordionItem value="item-1" className="border-none">
          <AccordionTrigger className="h-14 px-0">
            <span>How to connect the game</span>
            <ChevronDownIcon />
          </AccordionTrigger>
          <AccordionContent className="border-t border-coolgray-20 px-0">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi.
          </AccordionContent>
        </AccordionItem>
        <AccordionItem className="border-none" value="item-2">
          <AccordionTrigger className="h-14 px-0">
            <span>Purchase inquiry</span>
            <ChevronDownIcon />
          </AccordionTrigger>
          <AccordionContent className="border-t border-coolgray-20 px-0">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi.
          </AccordionContent>
        </AccordionItem>
        <AccordionItem className="border-none" value="item-3">
          <AccordionTrigger className="h-14 px-0">
            <span>Returns & Refunds inquiry</span>
            <ChevronDownIcon />
          </AccordionTrigger>
          <AccordionContent className="border-t border-coolgray-20 px-0">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi.
          </AccordionContent>
        </AccordionItem>
      </Accordion>

      <div className="mb-16 mt-5 flex items-center border-t border-coolgray-20 pt-5 laptop:mb-24">
        <p className="flex-1">Still need help?</p>
        <Button size="sm" variant="darkgray-fill" shape="pill" className="px-6">
          Contact Support
        </Button>
      </div> */}

      <div className="relative flex w-full flex-col items-center justify-center overflow-hidden rounded-lg bg-coolgray-10 px-6 py-9 laptop:rounded-2xl laptop:py-[50px]">
        <Image
          src="/images/games/detail/inquiry.png"
          alt="inquiry"
          className="absolute hidden object-cover laptop:block"
          fill
        />
        <Image
          src="/images/games/detail/inquiry-m.png"
          alt="inquiry"
          className="absolute object-cover laptop:hidden"
          fill
        />
        <p className="z-10 mb-8 text-center text-2xl text-white">
          {t("Do you have any feedback on the game?")}
        </p>
        <ReviewAndOpinionDialog
          reviewCount={game.reviewCount}
          contentId={game.id}
          slug={game.slug}
          contentName={game.name}
          view="write-opinion"
        />
      </div>
    </div>
  );
}
